module.exports = __webpack_public_path__ + "static/who-we-are-hero.db552b94.webp";